export default __webpack_public_path__ + "static/media/kid02.b5a2c26c.jpg";